import moment from 'moment';

export const compareDates = (date1: Date, date2: Date) =>
  moment(date1).format('YYYY-MM-DD') === moment(date2).format('YYYY-MM-DD');
